module.exports = {
    categorys: [{
            location: "市區",
            stopsName: "公車總站(火車站)",
            isexpanded: false, // 判斷站牌按鈕開關
            stopId: 1
        },
        {
            location: "市區",
            stopsName: "海洋廣場",
            isexpanded: false,
            stopId: 2
        },
        {
            location: "市區",
            stopsName: "義二路(廟口)",
            isexpanded: false,
            stopId: 3
        },
        {
            location: "市區",
            stopsName: "城隍廟",
            isexpanded: false,
            stopId: 4
        },
        {
            location: "北海岸",
            stopsName: "基隆地標(虎仔山)",
            isexpanded: false,
            stopId: 5
        },
        {
            location: "北海岸",
            stopsName: "仙洞巖",
            isexpanded: false,
            stopId: 6
        },
        {
            location: "北海岸",
            stopsName: "仙洞國小(鮮魚湯)",
            isexpanded: false,
            stopId: 7
        },
        {
            location: "北海岸",
            stopsName: "白米甕砲台",
            isexpanded: false,
            stopId: 8
        },
        {
            location: "北海岸",
            stopsName: "外木山漁港",
            isexpanded: false,
            stopId: 9
        },
        {
            location: "北海岸",
            stopsName: "海興海水泳池",
            isexpanded: false,
            stopId: 10
        },
        {
            location: "北海岸",
            stopsName: "情人湖濱海步道",
            isexpanded: false,
            stopId: 11
        },
        {
            location: "北海岸",
            stopsName: "外木山沙灘",
            isexpanded: false,
            stopId: 12
        },
        {
            location: "北海岸",
            stopsName: "大武崙(砲台,老鷹岩)",
            isexpanded: false,
            stopId: 13
        },
        {
            location: "北海岸",
            stopsName: "情人湖",
            isexpanded: false,
            stopId: 14
        },
        {
            location: "北海岸",
            stopsName: "新山水庫(武嶺街口)",
            isexpanded: false,
            stopId: 15
        },
        {
            location: "北海岸",
            stopsName: "萬里翡翠灣",
            isexpanded: false,
            stopId: 16
        },
        {
            location: "北海岸",
            stopsName: "龜吼漁港",
            isexpanded: false,
            stopId: 17
        },
        {
            location: "北海岸",
            stopsName: "野柳",
            isexpanded: false,
            stopId: 18
        },
        {
            location: "北海岸",
            stopsName: "金山老街",
            isexpanded: false,
            stopId: 19
        },
        {
            location: "東北角",
            stopsName: "和平島",
            isexpanded: false,
            stopId: 20
        },
        {
            location: "東北角",
            stopsName: "海洋大學",
            isexpanded: false,
            stopId: 21
        },
        {
            location: "東北角",
            stopsName: "海科館-碧水巷(女巫)",
            isexpanded: false,
            stopId: 22
        },
        {
            location: "東北角",
            stopsName: "潮境公園",
            isexpanded: false,
            stopId: 23
        },
        {
            location: "東北角",
            stopsName: "望海巷",
            isexpanded: false,
            stopId: 24
        },
        {
            location: "東北角",
            stopsName: "象鼻岩(深奧漁港)",
            isexpanded: false,
            stopId: 25
        },
        {
            location: "東北角",
            stopsName: "水湳洞(陰陽海)",
            isexpanded: false,
            stopId: 26
        },
        {
            location: "東北角",
            stopsName: "南雅",
            isexpanded: false,
            stopId: 27
        },
        {
            location: "東北角",
            stopsName: "鼻頭角",
            isexpanded: false,
            stopId: 28
        },
        {
            location: "東北角",
            stopsName: "龍洞",
            isexpanded: false,
            stopId: 29
        },
        {
            location: "東北角",
            stopsName: "澳底",
            isexpanded: false,
            stopId: 30
        },
        {
            location: "東北角",
            stopsName: "貢寮",
            isexpanded: false,
            stopId: 31
        },
        {
            location: "東北角",
            stopsName: "福隆",
            isexpanded: false,
            stopId: 32
        },
        {
            location: "東北角",
            stopsName: "瑞芳",
            isexpanded: false,
            stopId: 33
        },
        {
            location: "東北角",
            stopsName: "九份",
            isexpanded: false,
            stopId: 34
        },
        {
            location: "東北角",
            stopsName: "金瓜石",
            isexpanded: false,
            stopId: 35
        },
        {
            location: "山區",
            stopsName: "三坑",
            isexpanded: false,
            stopId: 36
        },
        {
            location: "山區",
            stopsName: "七堵",
            isexpanded: false,
            stopId: 37
        },
        {
            location: "山區",
            stopsName: "八堵",
            isexpanded: false,
            stopId: 38
        },
        {
            location: "山區",
            stopsName: "百福",
            isexpanded: false,
            stopId: 39
        },
        {
            location: "山區",
            stopsName: "瑪陵坑",
            isexpanded: false,
            stopId: 40
        },
        {
            location: "山區",
            stopsName: "暖暖",
            isexpanded: false,
            stopId: 41
        },
        {
            location: "山區",
            stopsName: "暖冬峽谷",
            isexpanded: false,
            stopId: 42
        },
        {
            location: "山區",
            stopsName: "碇內",
            isexpanded: false,
            stopId: 43
        },
        {
            location: "山區",
            stopsName: "四腳亭",
            isexpanded: false,
            stopId: 44
        }
    ],

    options: [{
            value: "101",
            stopId: [1, 2, 20, 21],
            switch: false,
            routeColor: "#99FF33"
        },
        {
            value: "103",
            stopId: [1, 2, 21, 22, 23, 24],
            switch: false,
            routeColor: "#00FF00"
        },
        {
            value: "104",
            stopId: [1, 2, 21],
            switch: false,
            routeColor: "#00AA00"
        },
        {
            value: "105",
            stopId: [2, 21],
            switch: false,
            routeColor: "#227700"
        },
        {
            value: "107",
            stopId: [1, 2, 3],
            switch: false,
            routeColor: "#163800"
        },
        {
            value: "109",
            stopId: [1, 2, 20],
            switch: false,
            routeColor: "#005475"
        },
        {
            value: "201",
            stopId: [1, 2, 3],
            switch: false,
            routeColor: "#FFD166"
        },
        {
            value: "202",
            stopId: [1, 3],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "203",
            stopId: [1, 2, 3],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "204",
            stopId: [1, 2, 3],
            switch: false,
            routeColor: "#5b4b00"
        },
        {
            value: "2088",
            stopId: [3, 22],
            switch: false,
            routeColor: "#3c3c3c"
        },
        {
            value: "301",
            stopId: [5, 6, 7, 8],
            switch: false,
            routeColor: "#ea0000"
        },
        {
            value: "302",
            stopId: [6, 7, 8],
            switch: false,
            routeColor: "#FF5511"
        },
        {
            value: "303",
            stopId: [5],
            switch: false,
            routeColor: "#FFAA33"
        },
        {
            value: "304",
            stopId: [5, 6, 7],
            switch: false,
            routeColor: "#FFCC22"
        },
        {
            value: "305",
            stopId: [5, 6, 7, 8, 9, 10, 11],
            switch: false,
            routeColor: "#CCFF33"
        },
        {
            value: "308",
            stopId: [9],
            switch: false,
            routeColor: "#00DD77"
        },
        {
            value: "402",
            stopId: [4, 36, 37, 38, 39],
            switch: false,
            routeColor: "#7A7A3E"
        },
        {
            value: "403",
            stopId: [4, 36, 37, 38],
            switch: false,
            routeColor: "#2D3648"
        },
        {
            value: "406",
            stopId: [4, 36, 37, 38, 39],
            switch: false,
            routeColor: "#7B7B3D"
        },
        {
            value: "408",
            stopId: [4, 37, 38, 39],
            switch: false,
            routeColor: "##666666"
        },
        {
            value: "501",
            stopId: [4],
            switch: false,
            routeColor: "#3A0088"
        },
        {
            value: "502",
            stopId: [4],
            switch: false,
            routeColor: "#660077"
        },

        {
            value: "503",
            stopId: [36, 37, 38],
            switch: false,
            routeColor: "#5500FF"
        },
        {
            value: "505",
            stopId: [4, 13, 14, 15],
            switch: false,
            routeColor: "#9955FF"
        },
        {
            value: "508",
            stopId: [4, 12, 13, 14, 15],
            switch: false,
            routeColor: "#9F88FF"
        },
        {
            value: "509",
            stopId: [4, 13, 14, 15],
            switch: false,
            routeColor: "#E8CCFF"
        },
        {
            value: "510",
            stopId: [13, 14, 15, 37, 38],
            switch: false,
            routeColor: "#380057"
        },
        {
            value: "601",
            stopId: [4, 36, 44],
            switch: false,
            routeColor: "#0000CC"
        },
        {
            value: "602",
            stopId: [4, 36, 41],
            switch: false,
            routeColor: "#0066FF"
        },
        {
            value: "603",
            stopId: [4, 36, 41, 42],
            switch: false,
            routeColor: "#00BBFF"
        },
        {
            value: "605",
            stopId: [4, 36, 41],
            switch: false,
            routeColor: "#84D5F1"
        },
        {
            value: "607",
            stopId: [4, 36, 41],
            switch: false,
            routeColor: "#95DFCC"
        },
        {
            value: "1815",
            stopId: [16],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "1811",
            stopId: [21, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
            switch: false,
            routeColor: "#3c3c3c"
        },
        {
            value: "1812",
            stopId: [21, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
            switch: false,
            routeColor: "#3c3c3c"
        },
        {
            value: "790",
            stopId: [16, 17, 18, 19],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "862",
            stopId: [16, 17, 18, 19],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "953",
            stopId: [16, 17, 18],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "F923",
            stopId: [16],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "T99",
            stopId: [16, 17, 18, 25],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "791",
            stopId: [25, 26, 27, 28, 29, 30, 31, 32],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "T99",
            stopId: [16, 17, 18, 25],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "1051",
            stopId: [25],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "787",
            stopId: [33],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "788",
            stopId: [33, 34, 35],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "1003",
            stopId: [35],
            switch: false,
            routeColor: "#C7A600"
        },
        {
            value: "701",
            stopId: [37, 38, 40],
            switch: false,
            routeColor: "#AA7700"
        },
        {
            value: "702",
            stopId: [39],
            switch: false,
            routeColor: "#FFA488"
        },
        {
            value: "703",
            stopId: [37, 38, 40],
            switch: false,
            routeColor: "#FFBB66"
        },
        {
            value: "R66",
            stopId: [37],
            switch: false,
            routeColor: "#3c3c3c"
        }


    ],
    placeholder: "Placeholder",
    backgroundColor: "#cde4f5",
    textColor: "black",
    borderRadius: "1.5em",
    border: "1px solid gray",
    width: 180
}


// WEBPACK FOOTER //
// ./src/components/vue-dropdown/config-mapoptions.js